<template>
  <DialogHeader>Download file</DialogHeader>
  <DialogContent>
    <div class="mb-3">Are you sure you want to download this file?</div>
    <FileInfo :file="props.file">
      Size: {{ props.file.metadata.size }}
    </FileInfo>
  </DialogContent>
  <DialogFooter>
    <UiButton
      class="w-full tablet-h:w-auto mr-2.5 tablet-h:mr-2"
      @click="close()"
    >
      Cancel
    </UiButton>
    <UiButton class="w-full tablet-h:w-auto" primary @click="handleClick">
      Download
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'
import type { File } from '@/shared/graphql/router/graphql'
import FileInfo from '@/features/explorer/components/FileInfo.vue'

const { close, open } = useDialog()

const props = defineProps<{
  file: File
}>()

const handleClick = () => {
  open(Dialogs.ProcessingDownload, {
    props: { file: props.file },
  })
}
</script>
